const keyMirror = require("keymirror");

export const EVENTS = keyMirror({
    HTTP_ERROR: null
});
